import { render, staticRenderFns } from "./WidgetWrapper.vue?vue&type=template&id=416f6cce&scoped=true&"
import script from "./WidgetWrapper.vue?vue&type=script&lang=js&"
export * from "./WidgetWrapper.vue?vue&type=script&lang=js&"
import style0 from "./WidgetWrapper.vue?vue&type=style&index=0&id=416f6cce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f6cce",
  null
  
)

export default component.exports